import {
	RouteLocationNormalizedGeneric,
	RouteLocationRaw,
	RouteLocationResolved,
	RouteParamsGeneric,
	useRouter as useVueRouter,
} from "vue-router";
import { useAppTabs } from "~stores/useAppTabs.ts";

function useRouter() {
	const router = useVueRouter();
	const { addTab, sessionTabs } = useAppTabs();
	const previousUrl = computed(() => {
		return router.options.history.state.back as string;
	});

	const previousRoute = computed(() => {
		return router.resolve({ path: previousUrl.value });
	});

	const routeToTab = (destination: RouteLocationRaw, callerTitle?: string) => {
		const route: RouteLocationResolved = router.resolve(destination);
		const matchedRoute = route.matched[0];

		if (matchedRoute?.components?.default == undefined) {
			console.error(`No component found for route: ${destination}`);
			return;
		}

		let props = matchedRoute.props.default;
		if (props instanceof Function) props = props(route as RouteLocationNormalizedGeneric);

		let title = route.meta?.tabTitle as string | null | ((params: RouteParamsGeneric) => string | null);
		if (title instanceof Function) title = title(route.params);

		addTab({
			// The route's own name wins. Failing that, whatever the caller knows — the sidebar and the
			// global search both pass the menu item's title, which is the only human name a custom
			// page has before its own `setTabTitle` runs. The generic word is the last resort.
			title: title || callerTitle || (route.meta?.tabTitleFallback as string) || "Nieuw tabblad",
			fullPath: `${route.fullPath}${route.fullPath.includes("?") ? "&" : "?"}_t=${performance.now().toString()}`,
			props: typeof props === "object" ? props : undefined,
		});
	};

	return {
		...useVueRouter(),
		previousUrl,
		previousRoute,
		async push(route: RouteLocationRaw, options?: { title?: string }) {
			routeToTab(route, options?.title);
		},
		async replace(route: RouteLocationRaw, options?: { title?: string }) {
			routeToTab(route, options?.title);
		},
	};
}

export default useRouter;
